import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import { GenericResponse } from "@api-types/common";
import { httpClient } from "@utils";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";

export class BetBoosterApiService {
	static get baseUrl() {
		return `${WEBPACK_BET_BOOSTER_API_ADDRESS}/betbooster`;
	}
	static getRequestHeaders(context: ApiRequestContextData) {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static async getBettingTips(
		params?: {
			eventId?: string;
			tournamentId?: string;
		},
		options?: ContextOptions
	): Promise<GenericResponse<BettingTips[]>> {
		const context = getApiRequestContext(options);
		let url = `${this.baseUrl}/tips`;
		const queryParams = new URLSearchParams();

		if (params?.eventId) {
			queryParams.append("eventId", params.eventId);
		}
		if (params?.tournamentId) {
			queryParams.append("tournamentId", params.tournamentId);
		}

		const queryString = queryParams.toString();

		if (queryString) {
			url += `?${queryString}`;
		}

		return httpClient.get(url, this.getRequestHeaders(context));
	}
}
